import { computed, defineComponent } from '@vue/composition-api';
import router from '@/router';
import { OfferTab, offerTabRouteMap } from './offer-menu-items.constants';
import { Icon } from '@/components/Icon';
import { IconSize } from '@/components/Icon/icon.constants';
import { mdiOfficeBuildingOutline, mdiPackageVariant, mdiBillboard, } from '@mdi/js';
import { SystemRole } from '@/api/requests/users';
import { useRoleChecker } from '@/composables/use-role-checker';
export default defineComponent({
    name: 'OfferMenuItems',
    components: {
        Icon,
    },
    setup(_, ctx) {
        const { checkRole } = useRoleChecker(ctx);
        const menuItems = computed(() => {
            const items = [
                {
                    value: OfferTab.OBJECTS,
                    label: ctx.root.$t('offer-menu.objects').toString(),
                    icon: mdiOfficeBuildingOutline,
                },
                {
                    value: OfferTab.GOODS_AND_SERVICES,
                    label: ctx.root.$t('offer-menu.goods-and-services').toString(),
                    icon: mdiPackageVariant,
                },
            ];
            if (checkRole(SystemRole.SUPER_ADMIN).value) {
                items.unshift({
                    value: OfferTab.UNIFIED,
                    label: ctx.root.$t('offer-menu.unified').toString(),
                    icon: mdiBillboard,
                });
            }
            return items;
        });
        const currentRoute = computed(() => ctx.root.$route);
        const isActiveTab = (tab) => {
            const routeName = offerTabRouteMap[tab];
            return currentRoute.value.name === routeName;
        };
        const navigateToTab = (tab) => {
            const routeName = offerTabRouteMap[tab];
            const currentParams = currentRoute.value.params;
            const currentQuery = currentRoute.value.query;
            router.push({
                name: routeName,
                params: currentParams,
                query: currentQuery,
            });
        };
        return {
            menuItems,
            isActiveTab,
            navigateToTab,
            IconSize,
        };
    },
});
